import React from "react";
import styles from "./CtaStrip.module.css";
import { Reveal } from "../common/Reveal";

export default function CtaStrip() {
  return (
    <Reveal as="section" className={styles.ctaStrip} id="contact">
      <p className={styles.ctaText}>Looking for a first-class business partner?</p>
       <a href="/contact" className={styles.btnPrimarySmall}>Contact us</a>
    </Reveal>
  );
}
